import { Badge } from '@/components/ui/badge';

import type { GradeStyleInput } from './gradeStyle';

import { getGradeDisplay, getGradeStyle } from './gradeStyle';

interface GradeBadgeProps {
  grade: GradeStyleInput;
}

export default function GradeBadge({ grade }: GradeBadgeProps) {
  return (
    <Badge variant={'muted'} size={'sm'} border style={getGradeStyle(grade)} className={'cursor-default font-semibold'}>
      {getGradeDisplay(grade)}
    </Badge>
  );
}
